import { render, staticRenderFns } from "./MoveToExcludedConfirmationPopup.vue?vue&type=template&id=1bf9e078&scoped=true&"
import script from "./MoveToExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./MoveToExcludedConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "./MoveToExcludedConfirmationPopup.vue?vue&type=style&index=0&id=1bf9e078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf9e078",
  null
  
)

export default component.exports